<template>
  <div id="ExposureRentalAgreement" class="table-responsive-sm">
    <section >
      <vue-good-table
        ref="listAssetTable"
        title="Asset"
        :columns="columns"
        :rows="rows"
        max-height="600px"
        :totalRows="totalRecords"
        :pagination-options="{
                  enabled: true,
                  position:'top',
                  mode: 'records',
                  perPage: 50,
                  perPageDropdown:[50,100],
                  dropdownAllowAll: false,
              }"
        :search-options="{
                  enabled: false,
                  placeholder: 'Search Asset',
              }"
        :select-options="{
                  enabled: false,
                  selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                  selectionInfoClass: 'custom-class',
                  selectionText: 'rows selected',
                  clearSelectionText: 'clear',
              }"
        :sort-options="{
                  enabled: true,
              }">
        <div slot="emptystate">
          No Data Found.
        </div>
      </vue-good-table>
    </section>
  </div>
</template>

<script>
export default {
  name: "CustomerExposureRentalAgreement",
  props: {
    tableData: Array,
  },
  mounted: function(){
    var self=this;
    self.rows = self.tableData;
  },
  data: () => ({
    columns: [
      {
        label: 'Contract #',
        field: 'agreement_no',
        filterable: true,
        sortable:false,
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: "Contract", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Asset #',
        field: 'unit_no',
        filterable: true,
        sortable:false,
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: "Asset", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Asset Type',
        field: 'vehicle_type',
        filterable: true,
        sortable:false,
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: "Asset Type", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Effective Date',
        field: 'effective_date',
        filterable: true,
        sortable:false,
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: "Effective Date", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Expiry Date',
        field: 'expiry_date',
        filterable: true,
        sortable:false,
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: "Expiry Date", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Total',
        field: 'total',
        filterable: true,
        sortable:false,
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: "Total", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
    ],
    rows: [],
    totalRecords: 0,
  })
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customer/CustomerExposureRentalAgreement.vue